<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount, setContext} from 'svelte';
    import BranchPath from '../Branch/BranchPath.svelte';
    import {
        draftElementDetails,
        activityVersion,
        elementDetails,
        elementInstance,
        elementTypes,
        location,
        branchId,
        roles,
        selectedSequence,
        standaloneEdit,
        triggerNewDraftElementVersionCreation,
        csrfMiddlewareToken,
        defaultElementTypeKey,
        lastLMIKey,
        lastExecutionConditionKey,
        isMaterialRiskControlSelected,
        isSaveEdit
    } from '../Workspaces/workspacesStore.js';
    import Thumbnail from '../common/Media/Thumbnail.svelte';
    import DuplicateCheckTextInput from '../DuplicateCheckTextInput.svelte';
    import NumberInput from '../NumberInput.svelte';
    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import {
        clearSequenceListSelection,
        removeLocalDraftElementVersion,
        addLocalNewDraftElementVersion,
        addElementToLocalWorksequence, setSelectedElements,
        updateLocalElementInstance, getLocalElementInstance, getWorkSequence
    } from '../Workspaces/RoleSequenceList/utils.js';
    import TagSelect from '../Tag/TagSelect.svelte';
    import ElementMediaInput from './Media/ElementMediaInput.svelte';
    import Messages from '../common/Messages.svelte';
    import ConfirmationModal from '../ConfirmationModal.svelte';
    import ElementTypeDropdown from './ElementTypeDropdown.svelte';
    import yup from 'yup';
    import {submit, get, post} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    import Spinner from '../Spinner.svelte';
    import KeyPointEditor from './KeyPointsEditor.svelte';
    import MaterialRiskDisplay from '../Workspaces/ElementView/MaterialRisk.svelte';
    import MaterialRiskEditor from './MaterialRiskEditor.svelte';
    import ToolEditor from './ToolEditor.svelte';
    import PartEditor from './PartEditor.svelte';
    import ReferenceDocumentEditor from "./ReferenceDocumentEditor.svelte";

    import QualityQuestionEditor from './QualityQuestionEditor.svelte';
    import PromoteToCurrent from './PromoteToCurrent.svelte';
    import RisksAndControls from './RisksAndControls/RisksAndControls.svelte';
    import RisksAndControlsEditor from './RisksAndControls/RisksAndControlsEditor.svelte';
    import {validateForm} from '../Form/utils.js';
    import {elementTabs} from '../Workspaces/tabStore.js';
    import Button from '../Button.svelte';
    import ElementMediaLibrary from './Media/ElementMediaLibrary.svelte';
    import {ElementVersionEntity} from './constants.js';
    import ElementMediaMarker from './Media/ElementMediaMarker.svelte';
    import Switch from '../common/Switch.svelte';
    import Errors from '../Errors.svelte';
    import ActivityUsageItem from './ActivityUsageItem.svelte';
    import {setActiveTab, toggleTabHide} from '../TabView/TabView.svelte';
    import ContextualText from '../Workspaces/ElementView/ContextualText.svelte';
    import AssetExecutionDetails from './AssetExecutionDetails.svelte';
    import KeyPointTable from '../Workspaces/ElementView/KeyPointTable.svelte';
    import QuestionsTable from '../Workspaces/ElementView/QuestionsTable.svelte';
    import ToolTable from '../Workspaces/ElementView/ToolTable.svelte';
    import PartTable from '../Workspaces/ElementView/PartTable.svelte';
    import Section from '../common/Section.svelte';
    import TagDisplay from '../Tag/TagDisplay.svelte';
    import {ELEMENT_INSTANCE_CONTEXTUAL_API} from '../../apiUrls.js';
    import CorrectiveAction from './CorrectiveAction.svelte';
    import ReferenceDocumentTable from '../Workspaces/ElementView/ReferenceDocumentTable.svelte';
    import ContextualFieldLink from '../ContextualFieldLink.svelte';
    import ContextualTextInput from '../ContextualTextInput.svelte';
    import ContextualLabel from '../ContextualLabel.svelte';
    import TabLink from '../TabLink.svelte';
    import { getSetting, setSetting } from '../../utils';

    export let contextualEdit = false;
    export let focus = undefined;
    $: elementFromAPM = false;
    export let display_as_aies=false;
    let destroying = false;
    let details = null;
    let saving = false;
    let savingAsCurrent = false;
    let savingAsCurrentAddNew = false;
    let savingElement = false;
    let promoteToCurrentModalId = 'promoteToCurrentModal';
    let elementMediaLibraryId = 'elementMediaLibrary';
    let elementMediaLibraryTitle = sgettext('$$ELEMENT_MEDIA_LIBRARY$$');
    let materialRiskEditorModalId = 'materialRiskEditorModal';
    let markupMediaModalId = 'markupMediaModal';
    let removeMarkupConfirmationModalId = 'removeMarkupConfirmationModal';

    let getTagsApi = `${PATH_PREFIX}/sw/api/elements_database/element_tags/`;
    let competenciesApiUrl =
            `${PATH_PREFIX}/sw/api/elements_database/element_version/competencies/available/`;
    let reportingGroupsApiUrl =
            `${PATH_PREFIX}/sw/api/elements_database/element_version/{0}/reportinggroups/available/`;
    let mainMediaUploadApiUrl = '';
    let elementVersionApiUrl = `${PATH_PREFIX}/sw/api/elements_database/elementversions/`;
    let draftElementVersionViewApiUrl =
            `${PATH_PREFIX}/sw/api/elements_database/draft_element_version/`;
    let elementApiUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/`;
    let setCompetenciesUrl = `${PATH_PREFIX}/sw/api/elements_database/element_version/competencies/set/`;
    let setElementTagsUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/{elementId}/set_element_tags/`;
    let setReportingGroupsUrl = `${PATH_PREFIX}/sw/api/elements_database/element_version/reportinggroups/set/`;
    let getNextVersionNumberApi =
            `${PATH_PREFIX}/sw/api/elements_database/elements/{elementId}/next_version_number/`;
    let elementMediaUploadApi =
            `${PATH_PREFIX}/sw/api/elements_database/elements/{0}/upload_media/`;
    let elementSlidesApi = `${PATH_PREFIX}/sw/api/elements_database/elementslides/`;
    let elementVersionId = 0;
    let newVersionState = false;
    let deletingMainMedia = false;
    let deletingContextualMedia = false;
    let deleteMainMediaConfirmationId = 'deleteMainMediaConfirmationModal';
    let deleteContextualMediaConfirmationId = 'deleteContextualMediaConfirmationModal';
    let deleteDraftConfirmationId = 'deleteDraftConfirmationModal';
    let selectedSlideId = 0;
    let selectedSlideRowId = 0;
    let markupMediaApi = `${PATH_PREFIX}/sw/api/elements_database/elementslides/{id}/markup_element_media/`;
    let savingMarkup = false;
    let mediaError = null;
    let showWarning = false;
    let createNewAfterPromote = false;
    let deletingDraft = false;
    let activityUsage = [];
    let getActivityUsageApi = `${PATH_PREFIX}/sw/api/elements_database/elementelementversions/{eevId}/activity_usage/`;
    let deleteDraftElementVersionApi = `${PATH_PREFIX}/sw/api/elements_database/elementelementversions/{eevId}/draft/`;
    let promoteToCurrentApi = `${PATH_PREFIX}/sw/api/elements_database/elementelementversions/{eevId}/promote_to_current/`;
    let newElementState = false;
    let elementNameDuplicateCheckApi = `${PATH_PREFIX}/sw/api/elements_database/elements/check_duplicate/`;
    const elementPersistentDetailsKey = 'new-element-persistent-details';

    $: showWarning =
            $draftElementDetails &&
            $draftElementDetails.warnings &&
            $draftElementDetails.warnings.length;
    $: newElementState = ($standaloneEdit && $draftElementDetails && $draftElementDetails.elementId === 0) || (!$standaloneEdit && $elementInstance && !$elementInstance.id);

    $: editElementState = details && details.evId;
    $: isSafetyElement = details && details.type === 'SAFETY';
    $: actionText = saving ? sgettext('$$SAVING_1$$') : sgettext('$$EDITING$$');
    $: allowGeneralInfoCollapse = !newElementState;
    $: elementIsArchived = $elementDetails ? $elementDetails.archived : false;

    $: hasWorkSequence = Boolean($elementInstance.worksequenceId);

    let nextVersionNumber = 0;

    let fieldValidations = getDefaultFieldValidations();

    $: mechanismListPlacement = $standaloneEdit ? 'auto' : 'absolute-bottom-right';
    $: mechanismListAbsoluteParentId = $standaloneEdit ? undefined : 'left-right-layout';
    $: mechanismListAbsoluteScrollParentSelector = $standaloneEdit ? undefined : '.tab-content';

    const elementVersionSchema = yup.object().shape({
        name: yup.string()
            .test('len', sgettext('$$TITLE_CANNOT_EXCEED_350_CHARACTERS$$'), val => val.length <= 350)
            .required(sgettext('$$TITLE_REQUIRED_FIELD$$'))
            .typeError(sgettext('$$TITLE_REQUIRED_FIELD$$')),
        time: yup
                .number()
                .min(0)
                .max(99999)
                .integer(sgettext('$$TIME_MUST_INTEGER$$'))
    });

    const elementSchema = yup.object().shape({
        name: yup.string()
            .test('len', sgettext('$$TITLE_CANNOT_EXCEED_350_CHARACTERS$$'), val => val.length <= 350)
            .required(sgettext('$$TITLE_REQUIRED_FIELD$$'))
            .typeError(sgettext('$$TITLE_REQUIRED_FIELD$$')),
        time: yup
                .number()
                .min(0)
                .max(99999)
                .integer(sgettext('$$TIME_MUST_INTEGER$$')),
        element_type: yup
                .string()
                .required(sgettext('$$TYPE_REQUIRED_FIELD$$'))
                .typeError(sgettext('$$TYPE_REQUIRED_FIELD$$')),
        contextual_time: yup
                .number()
                .min(0)
                .max(99999)
                .integer(sgettext('$$CONTEXTUAL_TIME_MUST_INTEGER$$')),
        defect_qqs: yup.boolean().nullable(),
        
        
    });

    const element = {};
    let fioriGoverned = false;
    let apmGoverned = false;
    $: initAndGetDetails($elementDetails);

    async function initAndGetDetails(eDetails) {
        if (contextualEdit) {
            // Here we need some data that getElementVersionDetails fetches for us
            // Unfortunately it also clobbers our view state, so we need to take a
            // deep clone of it first. Yeah this is pretty horrible.
            const detailsCopy = JSON.parse(JSON.stringify(eDetails));
            // Now call getElementVersionDetails, just so we can get element_slide
            await getElementVersionDetails();
            // overwrite view details with passed in eDetails, but include element_slide
            details = { element_slide: details.element_slide, ...detailsCopy};
            editElementState = details && details.evId
        } else {
            if (eDetails && eDetails.elementId) {
                await getElementVersionDetails();
            } else {
                if (fieldValidations.name.isValid && fieldValidations.element_type.isValid) {
                    initNewElement();
                }
            }

            fioriGoverned = checkForFioriGovernance();
            apmGoverned = checkForAPMGovernance();

        }

    }

    setContext('showMarkerModal', {
        showMarkerModal,
    });

    setContext('showMarkerRemovalConfirmationModal', {
        showMarkerRemovalConfirmationModal,
    });

    setContext('onRemoveMarkupConfirmed', {
        removeMarkupConfirmed,
    });

    function checkForFioriGovernance() {
        var govern = !$standaloneEdit && $activityVersion.is_fiori_governed
                ? true
                : $elementDetails
                        ? $elementDetails.is_fiori_governed
                        : false;
        var type = $elementDetails
                ? $elementDetails.type
                : details
                        ? details.type
                        : '';

        return govern && (type == 'QUALITY' || type == 'PART');
    }

    function checkForAPMGovernance() {
      return elementFromAPM || !$standaloneEdit
    }

    function initNewElement() {
        elementVersionId = 0;
        details = initialDetails();
    }

    function editTabIsActive() {
        return $elementTabs && $elementTabs.edit && $elementTabs.edit.active;
    }

    function initialDetails() {
        let storedKey = getSetting("element-creation-element-type") || null;
        return {
            competencies: [],
            eevId: 0,
            elementId: 0,
            evId: 0,
            hazardscontrols: [],
            keypoints: [],
            reference_documents: [],
            damage_group_options: null,
            location: $location,
            global_hazard: null,
            global_control: null,
            mainMedia: null,
            name: '',
            questions: [],
            reportingGroups: [],
            tags: [],
            time: 0,
            torch: false,
            type: storedKey ? storedKey :`${$elementTypes[2].id}`,

            version: 0,
            warnings: [],
        };
    }

    async function getElementVersionDetails() {
        const elementId = $elementDetails ? $elementDetails.elementId : 0;
        if (elementId) {
            const elementInstanceParam = $elementInstance.id ? `?elementInstanceId=${$elementInstance.id}` : '';
            const resp = contextualEdit ? await get(`${PATH_PREFIX}/sw/api/elements_database/element_from_instance/${$elementInstance.id}/`) : await get(`${draftElementVersionViewApiUrl}${elementId}/${elementInstanceParam}`);
            draftElementDetails.set(null);
            if (resp.ok) {
                const json = await resp.json();
                elementFromAPM = json.element_from_apm
                details = json;
                details.competencies = json.competencies.map((c) => ({
                    id: c.competency,
                    name: c.name,
                }));
                elementVersionId = details.evId;
                draftElementDetails.set(details);
            } else {
                details = initialDetails();
                await getVersionNumber($elementDetails.elementId);
                newVersionState = true;
            }
        }
        fieldValidations = getDefaultFieldValidations();
    }

    async function rawPartialSave(field, value) {
        if (elementVersionId) {
            const url = `${elementVersionApiUrl}${elementVersionId}/`;
            const payload = {
                [field]: value,
            };

            let method = 'PATCH';

            saving = true;
            const resp = await submit(url, method, payload);

            if (resp.ok) {
                const json = await resp.json();
                draftElementDetails.set({...$draftElementDetails, [field]: json[field]});
            }

            saving = false;
        }
    }

    async function partialSave(event) {
        return await rawPartialSave(event.currentTarget.id, event.currentTarget.value)
    }
    
    async function handleInspectionElementChange(event){
        // potentially a better way to do this? backend null values dont mix well with the frontend.
            if(event.detail.value == "None"){
                return await rawPartialSave("inspection_element", null)
            }
            else{
                return await rawPartialSave("inspection_element", "Asset Integrity")
            }
        
    }

    async function contextualUpdate(event) {
        return await rawContextualUpdate($elementInstance.id, event.currentTarget.id, event.currentTarget.value)
    }

    async function handleSuffixUpdate(event) {
        return await rawContextualUpdate($elementInstance.id, event.currentTarget.id, event.currentTarget.value === "" ? null : event.currentTarget.value)
    }

    async function handleQQSchange(event){
        return await rawContextualUpdate($elementInstance.id, "defect_qqs", event.currentTarget.checked)
    }

    async function handleDamageGroupUpdate(event){
        return await rawContextualUpdate($elementInstance.id, event.detail.key, event.detail.value === "" ? null : event.detail.value)
    }

    async function handleInspectionLocationUpdate(event){
        return await rawContextualUpdate($elementInstance.id, event.detail.key, event.detail.value)

    }

    async function rawContextualUpdate(elementInstanceId, field, value) {
        if (elementInstanceId) {
            const url = `${ELEMENT_INSTANCE_CONTEXTUAL_API}${elementInstanceId}/`;
            const payload = {
                [field]: value,
            };

            let method = 'PATCH';

            saving = true;
            const resp = await submit(url, method, payload);
            if (resp.ok) {
                const json = await resp.json();
                elementDetails.set({...$elementDetails, ...json, contextual_photo: details.contextual_photo});

                const updatedInstance = getLocalElementInstance($roles,
                        $elementInstance.roleId,
                        $elementInstance.worksequenceId,
                        $elementInstance.id);

                if (field === 'contextual_time') {
                    updatedInstance.total_time = parseInt(value);
                } else {
                    updatedInstance[field] = value;
                }

                roles.set(updateLocalElementInstance($roles,
                        $elementInstance.roleId,
                        $elementInstance.worksequenceId,
                        updatedInstance.id, updatedInstance));
            }
            saving = false;
        }
    }

    async function namePartialSave() {
        /* The "name" field has its own unique save function because partialSave() doesn't work with the
        * DuplicateCheckTextInput. */
        if (elementVersionId) {
            const url = `${elementVersionApiUrl}${elementVersionId}/`;

            const payload = {
                'name': details.name,
            };

            let method = 'PATCH';

            saving = true;
            const resp = await submit(url, method, payload);
            saving = false;
        }
    }


    async function handleTagChange(event) {
        if (event.detail) {
            if (details.elementId) {
                const url = `${setElementTagsUrl.replace(
                        '{elementId}',
                        details.elementId
                )}`;
                const payload = {
                    tags: event.detail.values.map((t) =>
                            t.hasOwnProperty('name') ? t.name : t
                    ),
                };

                let method = 'PATCH';

                saving = true;
                const resp = await submit(url, method, payload);
                saving = false;
            }
        }
    }

    async function handleCompetenciesChange(event) {
        if (event.detail) {
            if (elementVersionId) {
                const url = `${setCompetenciesUrl}${elementVersionId}/`;
                const payload = event.detail.values.map((c) => ({
                    competency: c.id,
                }));

                let method = 'PATCH';

                saving = true;
                const resp = await submit(url, method, payload);
                saving = false;
            }
        }
    }

    async function handleReportingGroupChange(event) {
        if (event.detail) {
            if (elementVersionId) {
                const url = `${setReportingGroupsUrl}${elementVersionId}/`;
                const payload = event.detail.values;

                let method = 'PATCH';

                saving = true;
                const resp = await submit(url, method, payload);
                saving = false;
            }
        }
    }

    function getDefaultFieldValidations() {
        return {
            name: {
                isValid: true,
                errors: '',
            },
            time: {
                isValid: true,
                errors: '',
            },
            element_type: {
                isValid: true,
                errors: '',
            },
            elementTags: {
                isValid: true,
                errors: '',
            },
            contextual_time: {
                isValid: true,
                errors: '',
            }
        };
    }

    let materialRiskNotSet = false;

    function validateMaterialRisk() {
        if (isSafetyElement) {
            try {
                materialRiskNotSet = !(
                        $draftElementDetails.materialRisk.hazard.id &&
                        $draftElementDetails.materialRisk.control.id
                );
                isMaterialRiskControlSelected.set(false);
            } catch (_errors) {
                materialRiskNotSet = true;
            }
        }
    }

    $: if (materialRiskNotSet) {
        validateMaterialRisk();
    }

    async function saveNewElement(editAfterSave) {
        if (fieldValidations.name.isValid && fieldValidations.element_type.isValid) {
            try {
                const payload = {
                    name: details.name,
                    branchId: $branchId,
                    element_type: details.type,
                    time: details.time,
                    worksequenceId: $elementInstance.worksequenceId,
                    index: $elementInstance.index,
                    save_edit: editAfterSave,
                    is_aies: display_as_aies,
                };

                if (isSafetyElement) {
                    validateMaterialRisk();
                    payload.global_hazard = $draftElementDetails.materialRisk
                        ? $draftElementDetails.materialRisk.hazard.id
                        : null;
                    payload.global_control = $draftElementDetails.materialRisk
                        ? $draftElementDetails.materialRisk.control.id
                        : null;
                }

                savingElement = true;
                await validateForm(elementSchema, payload);

                const resp = await submit(
                    `${elementApiUrl}new_sequence_element/`,
                    'POST',
                    payload
                );

                if (resp.ok) {
                    const json = await resp.json();

                    if (json.elementInstance) {
                        elementInstance.update((n) => ({
                            id: json.elementInstance.id,
                            name: json.elementInstance.name,
                            worksequenceId: n.worksequenceId,
                            roleId: n.roleId,
                            versions: json.elementInstance.versions,
                            actionId: json.elementInstance.action_id,
                            type: json.elementInstance.type,
                        }));

                        roles.set(
                            addElementToLocalWorksequence(
                                $roles,
                                $elementInstance.roleId,
                                $elementInstance.worksequenceId,
                                json.elementInstance
                            )
                        );

                        if (details.lowest_maintainable_item) {
                            try {
                                const lowest_maintainable_item = details.lowest_maintainable_item;
                                await rawContextualUpdate(
                                    $elementInstance.id,
                                    'lowest_maintainable_item',
                                    lowest_maintainable_item
                                )
                                updatePersistentElementDetails(JSON.stringify({
                                    lowest_maintainable_item
                                }));
                            } catch {
                                console.log('LMI failed to update (not fatal, but bad UX)')
                            }
                        }

                        setTimeout(scrollNewElementButtonToView, 500);
                    }

                    if (editAfterSave) {
                        if ($standaloneEdit) {
                            window.location.href = `${PATH_PREFIX}/sw/elements_database/${json.elementDetails.elementId}/#edit`;
                        } else {
                            elementDetails.set(json.elementDetails);
                            if (json.elementInstance) {
                                const selectedElement = getLocalElementInstance($roles, $elementInstance.roleId, $elementInstance.worksequenceId, $elementInstance.id);
                                roles.set(setSelectedElements($roles, [selectedElement], selectedElement.id));
                            }
                        }
                        // Simulate a click in the sequence list
                        await reloadElementDetails();
                    } else {
                        if (isSafetyElement && $standaloneEdit) {
                            draftElementDetails.set({...$draftElementDetails, type: 'SAFETY'});
                            draftElementDetails.set({...$draftElementDetails, materialRisk: null});
                        }

                        isSaveEdit.set(false);

                        if (elementDetails.materialRisk) {
                            elementDetails.materialRisk.set({});
                        }

                        elementDetails.set({}); // reset form
                        elementInstance.set({});
                    }
                }
            } catch (errors) {
                isSaveEdit.set(false);

                if (errors.inner) {
                    errors.inner.forEach((er) => {
                        fieldValidations[er.path].isValid = false;
                        fieldValidations[er.path].errors = er.message;
                    });
                }
            } finally {
                savingElement = false;
            }
        }
    }

    async function saveNewElementAndEdit() {
        await saveNewElement(true);
    }

    function scrollNewElementButtonToView() {
        const btn = document.getElementById(`createNewElementButton${$selectedSequence.id}`);

        if (btn) {
            const btnViewPort = btn.getBoundingClientRect();

            const body = document.getElementsByTagName('body')[0];
            const bodyViewPort = body.getBoundingClientRect();

            if (btnViewPort.bottom > (bodyViewPort.bottom - 90)) {
                btn.scrollIntoView({behavior: 'smooth', block: 'end'});
            }
        }
    }

    async function saveNewElementAndNew() {
        await saveNewElement(false);
        initNewElement();
        
        if (!$standaloneEdit) {
            jQuery(`#createNewElementButton${$selectedSequence.id}`).click();
        }
    }

    $: if ($triggerNewDraftElementVersionCreation) {
        createNewDraftElementVersion();
        triggerNewDraftElementVersionCreation.set(false);
    }

    async function createNewDraftElementVersion() {
        const payload = {
            elementId: $elementDetails.elementId,
            elementInstanceId: $elementInstance.id,
            name: $elementDetails.name,
            time: $elementDetails.time,
        };

        const url = `${elementVersionApiUrl}new_draft/`;
        const resp = await post(url, payload);
        if (resp.ok) {
            const json = await resp.json();
            details = {...json};
            elementFromAPM = json.element_from_apm
            draftElementDetails.set(details);
            details.competencies = json.competencies.map((c) => ({
                id: c.competency,
                name: c.name,
            }));
            if (!$standaloneEdit) {
                await getElementVersionDetails()
                updateLocalVersions(json);
            }
            elementVersionId = details.evId;
            newVersionState = false;
        } else {
             // TODO show error message
        }
    }

    function updateLocalVersions(newDraftVersion) {
        const newVersion = {
            id: newDraftVersion.eevId,
            elementId: newDraftVersion.elementId,
            status: 'DRAFT',
            version: {
                id: newDraftVersion.evId,
                number: newDraftVersion.version,
            },
        };
        elementInstance.update((ei) => {
            return {
                ...ei,
                versions: [
                    ...ei.versions,
                    newVersion
                ],
            };
        });
        roles.set(addLocalNewDraftElementVersion($roles, $elementInstance.roleId, $elementInstance.worksequenceId,
                $elementInstance.id, newVersion));
    }

    async function getVersionNumber(elementId) {
        const url = getNextVersionNumberApi.replace('{elementId}', elementId);
        const resp = await get(url);
        if (resp.ok) {
            nextVersionNumber = await resp.json();
        }
    }
    
    function handleRemoveMainMedia() {
        toggleDeleteMainMediaModal('show');
    }

    async function handleRemoveContextualMedia() {
        toggleDeleteContextualMediaModal('show');
    }

    async function removeContextualMedia() {
        if (details.contextual_photo) {
            const apiUrl = `${PATH_PREFIX}/sw/api/kendo/elementinstancemedia/${$elementInstance.id}/delete/`;
            deletingContextualMedia = true;
            const resp = await post(apiUrl, {});

            if (resp.ok) {
                details = {...details, contextual_photo: null};
                toggleDeleteContextualMediaModal('hide');
            }
            deletingContextualMedia = false;
        }

    }

    async function removeMainMedia() {
        if (details.element_slide) {
            deletingMainMedia = true;
            const resp = await submit(
                    `${elementSlidesApi}${details.element_slide.id}/`,
                    'DELETE'
            );
            deletingMainMedia = false;
            if (resp.ok) {
                details = {...details, element_slide: null};
                toggleDeleteMainMediaModal('hide');
            } else {
                //TODO: show error message
            }
        }
    }

    function toggleMediaMarkerModal(state) {
        jQuery(`#${markupMediaModalId}`).modal(state);
    }

    function toggleMediaMarkerRemovalConfirmationModal(state) {
        jQuery(`#${removeMarkupConfirmationModalId}`).modal(state);
    }

    function showMarkerModal(elementSlideId, rowId) {
        try {
            jQuery('iframe')[0].contentWindow.location.reload();
        } catch {
        }

        toggleMediaMarkerModal('show');
        selectedSlideId = elementSlideId;
        selectedSlideRowId = rowId;
    }

    function onMarkerModalCancel() {
        toggleMediaMarkerModal('hide');
    }

    async function onMarkerModalSave(iframe, elementSlideId, entityType) {
        const formId = `markup-${elementSlideId}-form`;
        const formData = new FormData(
                iframe.contentDocument.getElementById(formId)
        );
        const url = markupMediaApi.replace('{id}', elementSlideId);

        let jsonData = {};
        formData.forEach((value, key) => {
            jsonData[key] = value;
        });
        savingMarkup = true;
        const resp = await post(url, jsonData);
        if (resp.ok) {
            iframe.src = iframe.src;
            // iframe needs to be reloaded otherwise subsequent showings of the modal have the resulting response of the
            // previous save
            toggleMediaMarkerModal('hide');

            const json = await resp.json();
            updateLocalMediaAfterMarkerSaved(entityType, json, selectedSlideRowId);
        } else {
            //TODO: show error message
        }
        savingMarkup = false;
    }

    function updateLocalMediaAfterMarkerSaved(entity, slide, entityId) {
        if (entity === ElementVersionEntity.mainMedia) {
            updateLocalMainMedia(slide);
        } else {
            const entityListKey = `${entity}s`;
            updateLocalEntitySlide(slide, entityListKey, entityId);
        }
    }

    function showMarkerRemovalConfirmationModal(elementSlideId, rowId) {
        selectedSlideId = elementSlideId;
        selectedSlideRowId = rowId;
        toggleMediaMarkerRemovalConfirmationModal('show');
    }

    async function removeMarkupConfirmed(iframe, elementSlideId, entityType) {
        let url = `${PATH_PREFIX}/sw/api/elements_database/elementslides/${elementSlideId}/remove_markup_element_media/`;
        const resp = await submit(url, 'POST', []);

        const json = await resp.json();
        updateLocalMediaAfterMarkerSaved(entityType, json, selectedSlideRowId);
    }

    function cancelDeleteMainMedia() {
        toggleDeleteMainMediaModal('hide');
    }

    function cancelDeleteContextualMedia() {
        toggleDeleteContextualMediaModal('hide');
    }

    function toggleDeleteMainMediaModal(state) {
        jQuery(`#${deleteMainMediaConfirmationId}`).modal(state);
    }

    function toggleDeleteContextualMediaModal(state) {
        jQuery(`#${deleteContextualMediaConfirmationId}`).modal(state);
    }

    async function handleContextualMediaChange(media) {
        if (media && details.evId && details.elementId) {
            const url = `${PATH_PREFIX}/sw/elements_database/element_instance_media/async_create/`;
            const formData = new FormData();
            const metadata = {
                chunkIndex: 1,
                totalChunks: 1,
                contentType: media.type,
                totalFileSize: media.size,
                fileName: media.name,

            };
            formData.append('files', media);
            formData.append('element_instance_id', $elementInstance.id);
            formData.append('csrfmiddlewaretoken', $csrfMiddlewareToken);
            formData.append('metadata', JSON.stringify(metadata));

            mediaError = null;

            const resp = await submit(url, 'POST', formData, null, true);
            if (resp.ok) {
                const json = await resp.json();
                details = {...details, contextual_photo: json.contextual_photo};
            } else {
                mediaError = sgettext('$$ERROR_OCCURRED$$');
            }
        }
    }

    async function handleMainMediaChange(media) {
        if (media && details.evId && details.elementId) {
            const url = `${elementVersionApiUrl}${details.evId}/upload_main_media/`;
            const formData = new FormData();
            formData.append('media', media);
            formData.append('element_id', details.elementId);
            formData.append(
                    'element_slide_id',
                    details.element_slide ? details.element_slide.id : null
            );

            mediaError = null;

            const resp = await submit(url, 'POST', formData, null, true);
            if (resp.ok) {
                const json = await resp.json();
                details = {...details, element_slide: json};
            } else {
                mediaError = await resp.json();
            }
        }
    }


    async function showPromoteToCurrent() {
        if (details.version > 1) {
            jQuery(`#${promoteToCurrentModalId}`).modal('show');
            jQuery(`#${promoteToCurrentModalId}`).on('shown.bs.modal', function () {
                jQuery(`#comment`).trigger('focus');
            });
        } else {
            await promoteToCurrent();
        }
    }

    async function showPromoteToCurrentOnClick() {
        createNewAfterPromote = false;
        await showPromoteToCurrent();
    }

    async function showPromoteToCurrentAddNew() {
        createNewAfterPromote = true;
        await showPromoteToCurrent();

        clearSequenceListSelection($roles);
        roles.set([...$roles]);
    }

    async function promoteToCurrent() {
        /*
         This mostly duplicates functionality of the PromoteToCurrent modal with one small difference for when
         the we're trying to promote the very first version:

         It skips the requirement for a comment i.e. the modal is bypassed completely.
         */

        savingAsCurrent = true;
        // If we are promoting an element from within the context of an activity version, pass to the backend this id
        var url = promoteToCurrentApi.replace('{eevId}', details.eevId);
        if ($activityVersion && $activityVersion.id != 0) {
            url = url + `${$activityVersion.id}/`;
        }

        const payload = {
            comment: '',
        };

        if ($elementInstance && $elementInstance.id) {
            payload.elementInstanceId = $elementInstance.id;
        }

        const response = await submit(url, 'POST', payload);

        if (response.ok) {
            const json = await response.json();
            await onPromotedToCurrent(json);
        } else {
            let warnings = await response.json();
            let updatedElementDetails = {...$draftElementDetails};
            let translatedWarnings = [sgettext('$$UNABLE_PROMOTE_CURRENT$$')];
            for (let warning of warnings) {
                translatedWarnings.push(warning);
            }
            updatedElementDetails.warnings = translatedWarnings;
            draftElementDetails.set(updatedElementDetails);
            window.scrollTo(0, 0);
        }
        savingAsCurrent = false;
    }

    async function onPromotedToCurrent(newCurrentElementVersionJson) {
        elementDetails.set(newCurrentElementVersionJson);
        draftElementDetails.set(null);

        if (!$standaloneEdit) {
            const applicableVersion = $elementInstance.versions.find(
                    (v) => v.version.id === newCurrentElementVersionJson.evId
            );
            if (applicableVersion) {
                applicableVersion.status = sgettext('$$CURRENT_1$$');
            }
            elementInstance.update((n) => ({
                ...n,
                versions: [
                    ...n.versions.filter(
                            (v) => v.version.id !== newCurrentElementVersionJson.evId
                    ),
                    applicableVersion,
                ],
            }));

            // Update all relevant element instances with info from new version.
            for (let role of $roles) {
                for (let worksequence of role.worksequences) {
                    for (let ei of worksequence.element_instances.filter(
                            (e) => e.element_id === $elementDetails.elementId
                    )) {
                        ei.name = newCurrentElementVersionJson.name;
                        ei.total_time = newCurrentElementVersionJson.time;

                        const version = ei.versions.find(
                                (v) =>
                                        v.version.id === newCurrentElementVersionJson.evId
                        );
                        if (version) {
                            version.status = sgettext('$$CURRENT_1$$');
                            ei.versions = [
                                ...ei.versions.filter(
                                        (v) =>
                                                v.version.id !==
                                                newCurrentElementVersionJson.evId
                                ),
                                version,
                            ];
                            ei.status = sgettext('$$CURRENT$$');
                        }

                        roles.set(
                                updateLocalElementInstance(
                                        $roles,
                                        ei.roleId,
                                        ei.worksequenceId,
                                        ei.id,
                                        ei
                                )
                        );
                    }
                }
            }
        }


        if (createNewAfterPromote) {
            // show new element form
            if ($standaloneEdit) {
                window.location.href = `${PATH_PREFIX}/sw/elements_database/v1/create/`;
            } else {
                createNewElement();
            }
        } else {
            // show current version
            // set instanceDetail and highlight instance in list
            if (!$standaloneEdit) {
                const selected = getLocalElementInstance($roles, $elementInstance.roleId, $elementInstance.worksequenceId, $elementInstance.id)
                roles.set(setSelectedElements($roles, [selected], selected.id));
            }
            elementTabs.set(setActiveTab('view', $elementTabs));
        }
    }

    function createNewElement() {
        if ($elementInstance.worksequenceId) {
            selectedSequence.set(getWorkSequence($roles, $elementInstance.roleId, $elementInstance.worksequenceId));
            elementInstance.set({
                id: 0,
                name: name,
                worksequenceId: $elementInstance.worksequenceId,
                roleId: $elementInstance.roleId,
                versions: [],
                index: $selectedSequence.element_instances.length,
                actionId: $elementInstance.actionId,
                type: $elementInstance.type,
            });

            elementDetails.set(null);
            draftElementDetails.set(null);
            elementTabs.set(setActiveTab('edit', $elementTabs));
            elementTabs.set(toggleTabHide('edit', true, $elementTabs));
            elementTabs.set(toggleTabHide('view', true, $elementTabs));
            elementTabs.set(toggleTabHide('contextual', true, $elementTabs));
            setTimeout(() => {
                jQuery(`#name`).focus();
            }, 100);
        }
    }

    function updateLocalEntity(target, entityListKey) {
        const list = details[entityListKey];
        let filtered = list.filter((l) => l.id !== target.id);

        if (!target.id) {
            filtered = list.filter((l) => l.id);
        }

        filtered.push(target);
        filtered.sort((a, b) => a.sequence - b.sequence);

        details = {...details, [entityListKey]: filtered};
    }

    function updateLocalEntitySlide(slide, entityListKey, entityId) {
        const list = details[entityListKey];
        let filtered = list.find(l => l.id === entityId);

        if (filtered) {
            filtered.element_slide = slide;
        }
        details = {...details, [entityListKey]: [...list]};
    }

    function updateLocalMainMedia(mainMedia) {
        details = {...details, element_slide: mainMedia};
    }

    async function updateEntityMediaFromLibrarySelection(
            media,
            entity,
            entityListKey,
            apiUrl
    ) {
        if (entityListKey === ElementVersionEntity.mainMedia) {
            if (entity && entity.evId) {
                const payload = {
                    element_media_id: media.id,
                    element_slide_id: entity.element_slide
                            ? entity.element_slide.id
                            : 0,
                };
                const resp = await submit(apiUrl, 'POST', payload);
                if (resp.ok) {
                    const json = await resp.json();
                    updateLocalMainMedia(json);
                    toggleMediaLibraryModal('hide');
                }
            }
        } else {
            if (entity && entity.id) {
                //existing
                const payload = {
                    element_media_id: media.id,
                    item_id: entity.id,
                };
                const resp = await submit(apiUrl, 'POST', payload);
                if (resp.ok) {
                    const json = await resp.json();
                    updateLocalEntity(json, entityListKey);
                    toggleMediaLibraryModal('hide');
                }
            } else {
                //new
                entity.element_slide = {
                    ...media,
                    id: 0,
                    element_media_id: media.id,
                };
                updateLocalEntity(entity, entityListKey);
                toggleMediaLibraryModal('hide');
            }
        }
    }

    function toggleMediaLibraryModal(state) {
        jQuery(`#${elementMediaLibraryId}`).modal(state);
    }

    function toggleDeleteDraftModal(state) {
        jQuery(`#${deleteDraftConfirmationId}`).modal(state);
    }

    function handleSelectedMedia(customEvent) {
        const {media, target, entity} = customEvent.detail;
        let apiUrl = '';
        let entityListKey = '';
        switch (entity) {
            case ElementVersionEntity.tool:
                apiUrl = `${elementVersionApiUrl}${details.evId}/update_tool_media_from_library/`;
                entityListKey = 'tools';
                break;
            case ElementVersionEntity.part:
                apiUrl = `${elementVersionApiUrl}${details.evId}/update_part_media_from_library/`;
                entityListKey = 'parts';
                break;
            case ElementVersionEntity.keypoint:
                apiUrl = `${elementVersionApiUrl}${details.evId}/update_keypoint_media_from_library/`;
                entityListKey = 'keypoints';
                break;
            case ElementVersionEntity.mainMedia:
                apiUrl = `${elementVersionApiUrl}${details.evId}/update_main_media_from_library/`;
                entityListKey = 'mainMedia';
                break;
            default:
                break;
        }
        if (apiUrl) {
            updateEntityMediaFromLibrarySelection(
                    media,
                    target,
                    entityListKey,
                    apiUrl
            );
        }
    }

    async function handleMaterialRiskSelection() {
        if (details.type === 'SAFETY') {
            jQuery(`#${materialRiskEditorModalId}`).modal('show');
        } else {
            details.mechanism = null;
            details.global_hazard = {id: null};
            details.global_control = {id: null};
        }
        let selectedType = $elementTypes.filter(et => et.name.toLowerCase() === details.type.toLowerCase());
        setSetting("element-creation-element-type", selectedType[0].id)
    }

    async function showDeleteDraftConfirmation() {
        const resp = await get(getActivityUsageApi.replace('{eevId}', details.eevId));

        if (resp.ok) {
            activityUsage = await resp.json();
        }
        toggleDeleteDraftModal('show');
    }

    async function deleteDraftVersion() {
        deletingDraft = true;
        const resp = await submit(deleteDraftElementVersionApi.replace('{eevId}', details.eevId), 'DELETE');

        if (resp.ok) {
            const deletedElementDetails = await resp.json();
            if (!jQuery.isEmptyObject(deletedElementDetails)) {
                elementDetails.set(deletedElementDetails);
            }

            if (!$standaloneEdit) {
                roles.set(removeLocalDraftElementVersion($roles, $elementInstance.roleId, $elementInstance.worksequenceId,
                        $elementInstance.id, details.eevId));
                $elementInstance.versions = $elementInstance.versions.filter(v => v.status !== 'DRAFT');
                elementInstance.set({...$elementInstance});
            }

            closeDeleteDraftModal();
            elementTabs.set(setActiveTab('view', $elementTabs));
            draftElementDetails.set(null);
        }
        deletingDraft = false;
    }

    function closeDeleteDraftModal() {
        activityUsage = [];
        toggleDeleteDraftModal('hide');
    }

    async function persistentContextualUpdate(event) {
        const { currentTarget: { id: field, value}} = event;
        const response = await contextualUpdate(event);

        // only do this for new elements for now
        if (newElementState) {
            // don't persist empty values
            if (value && value.trim()) {
                updatePersistentElementDetails({[field]: value})
            }
        }
        return response;
    }

    function getPersistentElementDetails(...forFields) {
        // only do this for new elements for now
        if (newElementState) {
            const persistentDetails = JSON.parse(getSetting(elementPersistentDetailsKey) || '{}');
            // only update persistent items that are currently empty
            const toUpdate = Object.entries(persistentDetails).reduce((obj, [key, val]) => ({
                ...obj,
                ...(!details[key] && forFields.includes(key) ? {[key]: val} : {})
            }), {})
            details = {...details, ...toUpdate}
            // save anything we've autofilled
            Object.entries(toUpdate).forEach(([key, val]) => rawContextualUpdate($elementInstance.id, key, val));
        }
    }

    function updatePersistentElementDetails(toUpdate) {
        setSetting(
            elementPersistentDetailsKey,
            JSON.stringify({
                ...(JSON.parse(getSetting(elementPersistentDetailsKey) || '{}')),
                ...toUpdate
            })
        )
    }

    async function reloadElementDetails() {
        const url = `${PATH_PREFIX}/sw/api/elements_database/element_from_instance/${$elementInstance.id}/`;
        const response = await get(url);
        if (response.ok) {
            let updated = await response.json();
            elementDetails.set(updated);
        }
        loadingElementDetails.set(false);
        getIssuesCount();
    }

    onMount(async () => {
        if (!contextualEdit) {
            await getElementVersionDetails();
        }

        jQuery(`#${promoteToCurrentModalId}`).on('shown.bs.modal', function () {
            jQuery(`#comment`).trigger('focus');
        });
    });

    $: if(details) {
        if(details?.parts?.length > 0) {
            details.parts = details.parts.filter(p => !p.part?.expired)
        }
    }

</script>

{#if newElementState}
  <div>
    <h3>{sgettext('$$CREATE_NEW_ELEMENT$$')}</h3>
  </div>
{:else if details}
  {#if showWarning}
    <Messages type="warning" text={$draftElementDetails.warnings} />
  {/if}

  {#if details.evId && isSafetyElement}
    <MaterialRiskDisplay
      mechanism={$draftElementDetails?.materialRisk
        ? $draftElementDetails.materialRisk.mechanism
        : null}
      hazard={$draftElementDetails?.materialRisk
        ? $draftElementDetails.materialRisk.hazard
        : null}
      control={$draftElementDetails?.materialRisk
        ? $draftElementDetails.materialRisk.control
        : null}
    />
  {/if}
  <div class="title">
    {#if elementIsArchived}
      <label>{sgettext('$$ELEMENT_ARCHIVED$$')}</label>
    {:else}
      <h3 class="text-primary">
        {#if $standaloneEdit}
          {details.name}
          {#if details.suffix}
            <ContextualText>{details.suffix}</ContextualText>
          {/if}
        {/if}
      </h3>
      {#if details.evId}
        <label style="font-weight: normal;">
          {#if saving}
            <Spinner inline={true} size="small" text="saving" />
          {/if}
          {#if contextualEdit}
            {`${sgettext('$$VERSION$$')} ${details.version} (${sgettext(
              '$$CURRENT$$'
            )})`}
          {:else}
            {`${sgettext('$$VERSION$$')} ${details.version} (${sgettext(
              '$$DRAFT$$'
            )})`}
          {/if}
        </label>
      {:else}
        <label>
          {#if !contextualEdit}
            {sgettext('$$EXISTING_DRAFT_VERSION_NOT_FOUND_1$$')}
            <span class="btn-link" on:click={createNewDraftElementVersion}>
              {sgettext('$$CLICK_CREATE_DRAFT_VERSION_1$$')}
              {nextVersionNumber}
            </span>
            {#if saving}
              <Spinner size="small" text="saving" />
              {sgettext('$$SAVING_1$$')}...
            {/if}
          {/if}
        </label>
      {/if}
    {/if}
  </div>
{/if}

{#if (editElementState || newElementState || contextualEdit) && details && !elementIsArchived}
  <Section class={contextualEdit ? 'contextual-edit' : ''}>
    <span slot="header">
      <h4 class="text-secondary d-inline-block">
        {sgettext('$$GENERAL_INFORMATION$$')}
      </h4>
      {#if !newElementState}
        <span class="float-right"
          ><ContextualText
            >* {sgettext('$$CONTEXTUAL_UPDATES$$')}</ContextualText
          ></span
        >
      {/if}
    </span>
    <div
      class:edit={editElementState}
      class="{contextualEdit ? '' : 'greyBackground'} container-fluid"
      id="elementEditor"
    >
      <div class="row">
        <div class="col-md-7">
          <div class="general-details height-limiter">
            <table id="general-details">
              <tbody>
                <tr>
                  <th>{sgettext('$$TITLE$$')}*</th>
                  <td colspan="3">
                    {#if contextualEdit || (elementFromAPM && !newElementState)}
                      {details.name}
                    {:else}
                      <DuplicateCheckTextInput
                        id="name"
                        apiurl={elementNameDuplicateCheckApi}
                        message={sgettext('$$SIMILAR_ELEMENTS_FOUND$$')}
                        bind:value={details.name}
                        bind:isValid={fieldValidations.name.isValid}
                        bind:errors={fieldValidations.name.errors}
                        schema={elementVersionSchema}
                        on:check={namePartialSave}
                        redirectUrl={`${PATH_PREFIX}/sw/elements_database/{0}/?status=CURRENT&amp;back=/sw/elements_database/v1/create/?name={1}`}
                      />
                    {/if}
                  </td>
                </tr>
                {#if !$standaloneEdit && !newElementState && details?.display_as_aies && details.type === 'QUALITY' && details?.ev_inspection_element == 'Asset Integrity'}
                  <tr>
                    <th class="contextual">
                      {sgettext('$$INSPECTION_LOCATION$$')}
                    </th>
                    <td colspan="3">
                      {#if contextualEdit || newElementState}
                        <ComboSelect
                          id="inspection_location"
                          isContextual={true}
                          bind:value={details.inspection_location}
                          options={details.inspection_location_options.map(
                            function(inspection_location) {
                              return {
                                id: inspection_location.id,
                                name: inspection_location.long_name,
                              };
                            }
                          )}
                          on:changed={handleInspectionLocationUpdate}
                        />
                      {:else}
                        <ContextualText>
                          {details.inspection_location_name
                            ? details.inspection_location_name
                            : ''}
                          <ContextualFieldLink
                            focus="inspection_location"
                            value={details.inspection_location_name}
                          />
                        </ContextualText>
                      {/if}
                    </td>
                  </tr>
                {/if}
                {#if !$standaloneEdit && !newElementState}
                  <tr>
                    <th class="contextual">
                      {sgettext('$$TITLE_SUFFIX$$')}
                    </th>
                    <td colspan="3">
                      {#if (contextualEdit || newElementState) && !elementFromAPM}
                        <ContextualTextInput
                          id="suffix"
                          value={details.suffix}
                          object={details}
                          focus={focus === 'suffix'}
                          on:change={handleSuffixUpdate}
                        />
                      {:else}
                        <ContextualText>
                          {details.suffix ? details.suffix : ''}
                          {#if !elementFromAPM}
                            <ContextualFieldLink
                              focus="suffix"
                              value={details.suffix}
                            />
                          {/if}
                        </ContextualText>
                      {/if}
                    </td>
                  </tr>
                {/if}
                <tr>
                  <th style="min-width:160px">
                    {sgettext('$$LOCATION$$')}
                  </th>
                  <td colspan="3">
                    <BranchPath path={details.location} />
                  </td>
                </tr>
                <tr>
                  <th style="">{sgettext('$$TYPE$$')}*</th>
                  <td
                    style="vertical-align: top; padding-top: 8px;"
                    colspan="3"
                  >
                    {#if contextualEdit || (elementFromAPM && !newElementState)}
                      {details.type}
                    {:else if details.elementId === 0}
                      {#if details && details.type && $activityVersion?.activity_governance_type === 'APM Governed'}
                        <ComboSelect
                          id="element_type"
                          options={$elementTypes.filter(
                            (e) => e.id != 'QUALITY'
                          )}
                          bind:value={details.type}
                          bind:isValid={fieldValidations.element_type.isValid}
                          bind:errors={fieldValidations.element_type.errors}
                          on:changed={handleMaterialRiskSelection}
                          schema={elementSchema}
                          required="true"
                        />
                      {:else}
                        <ComboSelect
                          id="element_type"
                          options={$elementTypes}
                          bind:value={details.type}
                          bind:isValid={fieldValidations.element_type.isValid}
                          bind:errors={fieldValidations.element_type.errors}
                          on:changed={handleMaterialRiskSelection}
                          schema={elementSchema}
                          required="true"
                        />
                      {/if}
                    {:else}
                      <ElementTypeDropdown element={details} />
                    {/if}
                  </td>
                </tr>
                {#if !newElementState && details.type == 'QUALITY' && details?.ev_inspection_element == 'Asset Integrity'}
                  <tr>
                    <th style="min-width:160px">
                      {sgettext('$$INSPECTION$$')}
                    </th>
                    {#if !contextualEdit}
                      <td
                        style="vertical-align: top; padding-top: 8px;"
                        colspan="3"
                      >
                        <ComboSelect
                          id="ev_inspection_element"
                          ,
                          bind:value={details.ev_inspection_element}
                          on:changed={handleInspectionElementChange}
                          options={[
                            { id: 'Asset Integrity', name: 'Asset Integrity' },
                            { id: 'None', name: 'None' },
                          ]}
                        />
                      </td>
                    {:else if details.ev_inspection_element}
                      {details.ev_inspection_element}
                    {:else}
                      None
                    {/if}
                  </tr>
                {/if}
                {#if !$standaloneEdit && !newElementState && details.type === 'QUALITY' && details?.ev_inspection_element == 'Asset Integrity'}
                  <tr>
                    <th class="contextual">
                      {sgettext('$$DAMAGE_GROUP$$')}
                    </th>
                    <td colspan="3">
                      {#if contextualEdit && details.inspection_location__type != 'Area' && details?.display_as_aies}
                        <ComboSelect
                          id="damage_group_code"
                          isContextual={contextualEdit}
                          bind:value={details.damage_group_code}
                          options={details.damage_group_options.map(function(
                            damage_group
                          ) {
                            return {
                              id: damage_group.id,
                              name: damage_group.code,
                            };
                          })}
                          on:changed={handleDamageGroupUpdate}
                          disabled={details.inspection_location__type ==
                            'Area' ||
                            details.inspection_location__type == 'Point'}
                        />
                      {:else}
                        <ContextualText>
                          {details.damage_group_name
                            ? details.damage_group_name
                            : ''}
                          {#if details.inspection_location__type != 'Area'}
                            <ContextualFieldLink
                              focus="damage_group_code"
                              value={details.damage_group_name}
                            />
                          {/if}
                        </ContextualText>
                      {/if}
                    </td>
                  </tr>
                {/if}
                {#if hasWorkSequence && newElementState}
                  <tr>
                    <th style=""
                      ><ContextualLabel
                        >{sgettext(
                          '$$LOWEST_MAINTAINABLE_ITEM$$'
                        )}</ContextualLabel
                      ></th
                    >
                    <td
                      style="vertical-align: top; padding-top: 8px;"
                      colspan="3"
                    >
                      <ContextualTextInput
                        id="lowest_maintainable_item"
                        bind:value={details.lowest_maintainable_item}
                        on:change={persistentContextualUpdate}
                        on:focus={() =>
                          getPersistentElementDetails(
                            'lowest_maintainable_item'
                          )}
                      />
                    </td>
                  </tr>
                {/if}
                <tr>
                  <th style="padding-right: 15px;">
                    {sgettext('$$TIME$$')}
                  </th>
                  <td>
                    {#if contextualEdit}
                      {details.time}
                    {:else}
                      <NumberInput
                        id="time"
                        bind:value={details.time}
                        min={0}
                        max={99999}
                        inline={true}
                        style="width: 80px;"
                        object={details}
                        on:change={partialSave}
                        bind:isValid={fieldValidations.time.isValid}
                        bind:errors={fieldValidations.time.errors}
                        schema={elementVersionSchema}
                      />
                    {/if}
                    <span>&nbsp; {sgettext('$$SECS$$')}</span>
                  </td>
                  {#if !$standaloneEdit && !newElementState}
                    <th
                      class="contextual"
                      style="text-align: right; padding-right: 15px;"
                    >
                      {sgettext('$$CONTEXTUAL_TIME$$')}
                    </th>
                    <td>
                      {#if contextualEdit || newElementState}
                        <NumberInput
                          id="contextual_time"
                          additionalClass="contextual-input"
                          value={details.contextual_time}
                          min={0}
                          max={99999}
                          inline={true}
                          style="width: 80px;"
                          object={details}
                          on:change={contextualUpdate}
                          bind:isValid={fieldValidations.contextual_time
                            .isValid}
                          bind:errors={fieldValidations.contextual_time.errors}
                          schema={elementVersionSchema}
                          focus={focus === 'contextual_time'}
                        />
                        <span>&nbsp; {sgettext('$$SECS$$')}</span>
                      {:else}
                        <ContextualText
                          >{details.contextual_time
                            ? `${details.contextual_time} Secs`
                            : ''}</ContextualText
                        >
                        <ContextualFieldLink
                          focus="contextual_time"
                          value={details.contextual_time}
                        />
                      {/if}
                    </td>
                  {/if}
                </tr>
                {#if details.elementId !== 0}
                  <tr>
                    <th>{sgettext('$$TAGS$$')}</th>
                    <td colspan="3">
                      {#if contextualEdit}
                        <TagDisplay tags={details.tags} />
                      {:else}
                        <TagSelect
                          id="elementTags"
                          bind:values={details.tags}
                          filterKey="q"
                          optionsApiUrl={getTagsApi}
                          on:changed={handleTagChange}
                          allowNewOption={true}
                          maxSelection={10}
                          bind:isValid={fieldValidations.elementTags.isValid}
                          bind:errors={fieldValidations.elementTags.errors}
                        />
                      {/if}
                    </td>
                  </tr>

                  <tr>
                    <th>{sgettext('$$COMPETENCIES$$')}</th>
                    <td colspan="3">
                      {#if contextualEdit || elementFromAPM}
                        <TagDisplay tags={details.competencies} key="name" />
                      {:else}
                        <TagSelect
                          id="competencies"
                          bind:values={details.competencies}
                          filterKey="name"
                          on:changed={handleCompetenciesChange}
                          optionsApiUrl={`${competenciesApiUrl}${elementVersionId}/`}
                        />
                      {/if}
                    </td>
                  </tr>
                {/if}
                {#if !newElementState && details.type === 'QUALITY'}
                  <tr>
                    <th>{sgettext('$$REPORTING_GROUPS$$')}</th>
                    <td colspan="3" style="padding-bottom: 0">
                      {#if contextualEdit}
                        <TagDisplay tags={details.reportingGroups} key="name" />
                      {:else}
                        <TagSelect
                          id="reportingGroup"
                          placeholder={sgettext(
                            '$$CLICK_ADD_REPORTING_GROUP$$'
                          )}
                          bind:values={details.reportingGroups}
                          filterKey="name"
                          on:changed={handleReportingGroupChange}
                          optionsApiUrl={`${reportingGroupsApiUrl.replace(
                            '{0}',
                            elementVersionId
                          )}`}
                        />
                      {/if}
                    </td>
                  </tr>
                {/if}
                {#if false}
                  <tr>
                    <th>{sgettext('$$TORCH_ENABLED$$')}</th>
                    <td>
                      <Switch
                        id="torch_enabled"
                        bind:value={details.torch_enabled}
                        onChange={partialSave}
                      />
                    </td>
                  </tr>
                {/if}
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-5 main-photo-container">
          {#if details.elementId}
            <div class="general-details">
              {#if details.evId}
                {#if contextualEdit}
                  <label>{sgettext('$$CONTEXTUAL_PHOTO$$')}</label>
                  <div class="main-photo">
                    <div class="media">
                      <ElementMediaInput
                        bind:media={details.contextual_photo}
                        useMarker={false}
                        useMediaLibrary={false}
                        onChange={handleContextualMediaChange}
                        width="540px"
                        height="100%"
                        dropAreaStyle={!details.contextual_photo
                          ? 'height: 200px'
                          : ''}
                        row={details}
                        onRemove={handleRemoveContextualMedia}
                        allowRemove={true}
                        onShowMarker={showMarkerModal}
                        onRemoveMarkup={showMarkerRemovalConfirmationModal}
                      />
                    </div>
                    <Errors errors={mediaError} />
                  </div>
                  {#if details.contextual_photo && details.element_slide && details.element_slide.url}
                    <TabLink tab="edit">
                      [MAIN PHOTO exists will be overridden by above]
                    </TabLink>
                  {/if}
                {:else}
                  <label>{sgettext('$$MAIN_PHOTO$$')}</label>
                  <div class="main-photo">
                    <div class="media">
                      <ElementMediaInput
                        bind:media={details.element_slide}
                        useMarker={true}
                        useMediaLibrary={true}
                        onChange={handleMainMediaChange}
                        width="540px"
                        height="100%"
                        dropAreaStyle={!details.element_slide
                          ? 'height: 200px'
                          : ''}
                        mediaLibraryId={elementMediaLibraryId}
                        row={details}
                        entity={ElementVersionEntity.mainMedia}
                        onRemove={handleRemoveMainMedia}
                        allowRemove={true}
                        onShowMarker={showMarkerModal}
                        onRemoveMarkup={showMarkerRemovalConfirmationModal}
                      />
                    </div>
                    <Errors errors={mediaError} />
                  </div>
                  {#if details.contextual_photo}
                    <ContextualFieldLink
                      label={sgettext('$$VIEWEDIT_CONTEXTUAL_PHOTO$$')}
                    />
                  {:else if hasWorkSequence && details.element_slide}
                    <ContextualFieldLink
                      label={sgettext('$$ADD_CONTEXTUAL_PHOTO$$')}
                    />
                  {/if}
                {/if}
              {/if}
            </div>
          {/if}
        </div>
      </div>
    </div>
  </Section>

  {#if details.elementId === 0}
    <div class="details-row mb-3">
      <div>
        {#if details.type === 'SAFETY'}
          <div class="mt-3">
            <MaterialRiskEditor
              elementVersionId={details.evId}
              mechanismListPlacement="bottom-right"
            />
            {#if materialRiskNotSet && !$isMaterialRiskControlSelected}
              <span class="text-danger">
                {sgettext('$$MATERIAL_RISK_MUST_SET_SAFETY_ELEMENT$$')}
              </span>
            {/if}
          </div>
        {/if}
      </div>
    </div>
    <div class="buttons-bar">
      <Button
        name={sgettext('$$SAVE_NEW$$')}
        type="primary"
        sending={savingElement}
        disabled={savingElement}
        on:click={saveNewElementAndNew}
      />
      <Button
        name={sgettext('$$SAVE_EDIT$$')}
        type="primary"
        sending={savingElement}
        disabled={savingElement}
        on:click={saveNewElementAndEdit}
      />
    </div>
  {/if}

  {#if editElementState && details.elementId}
    <Section
      title={`${sgettext('$$RISKS_CONTROLS_1$$')} (${
        details.hazardscontrols.length
      })`}
    >
      <div id="scrollHazardControl">
        {#if contextualEdit}
          <RisksAndControls rows={details.hazardscontrols} />
        {:else if !destroying}
          <!--this if statement is required to fix svelte DOM bug when component is removed from view-->
          <RisksAndControlsEditor
            branchId={$branchId}
            bind:rows={details.hazardscontrols}
            eevId={details.eevId}
            elementId={details.elementId}
            activityVersionId={$activityVersion ? $activityVersion.id : null}
            {elementVersionId}
            {mechanismListPlacement}
            {mechanismListAbsoluteParentId}
            {mechanismListAbsoluteScrollParentSelector}
          />
        {/if}
      </div>
    </Section>
    {#if details.type === 'PART'}
      <Section title={`${sgettext('$$PARTS$$')} (${details.parts.length})`}>
        {#if contextualEdit}
          <PartTable rows={details.parts} />
        {:else}
          <PartEditor
            bind:rows={details.parts}
            eevId={details.eevId}
            elementId={details.elementId}
            {elementVersionId}
          />
        {/if}
      </Section>
    {/if}
    {#if details.type === 'QUALITY' || details.type === 'SAFETY' || details.type === 'KNACK'}
      <Section
        title={`${sgettext('$$KEY_POINTS$$')} (${details.keypoints.length})`}
      >
        {#if contextualEdit}
          <KeyPointTable rows={details.keypoints} />
        {:else}
          <KeyPointEditor
            bind:rows={details.keypoints}
            eevId={details.eevId}
            elementId={details.elementId}
            {elementVersionId}
            maxRows={details.max_keypoints}
          />
        {/if}
      </Section>
    {/if}
    {#if details.type === 'QUALITY' || details.type === 'SAFETY'}
      <Section
        title={`${sgettext('$$QUESTIONS$$')} (${details.questions.length})`}
      >
        {#if contextualEdit && details?.ev_inspection_element == 'Asset Integrity'}
          <div>
            {sgettext('$$DISPLAY_DEFECT_FORM_1$$')}
            <input
              type="checkbox"
              id="defect_qqs"
              on:change={handleQQSchange}
              bind:checked={details.defect_qqs}
              object={details}
              disabled="{details.inspection_location__type == 'Area' ||
                details.inspection_location__type == 'Point'},"
            />
          </div>
        {/if}
        {#if contextualEdit}
          <QuestionsTable rows={details.questions} />
        {:else}
          <QualityQuestionEditor
            bind:rows={details.questions}
            eevId={details.eevId}
            elementId={details.elementId}
            damageGroupOptions={details.damage_group_options}
            displayAIESOptions={details?.display_as_aies &&
              details.type == 'QUALITY' &&
              details?.ev_inspection_element == 'Asset Integrity'}
            {elementVersionId}
          />
        {/if}
      </Section>
    {/if}

    {#if !$standaloneEdit}
      <Section
        title={sgettext('$$ASSET_EXECUTION_DETAILS$$')}
        class={contextualEdit ? 'contextual-edit' : ''}
      >
        <AssetExecutionDetails
          model={details}
          editable={contextualEdit && !elementFromAPM}
          showEditLinks={!elementFromAPM}
          onChange={contextualUpdate}
          {focus}
          persistentOnChange={persistentContextualUpdate}
          persistentFields={['lowest_maintainable_item', 'execution_condition']}
          persistentOnFocus={getPersistentElementDetails}
          {elementFromAPM}
        />
      </Section>
    {/if}

    <Section title={sgettext('$$CORRECTIVE_ACTION$$')}>
      <CorrectiveAction
        model={details}
        editable={!contextualEdit && !elementFromAPM}
        onChange={partialSave}
      />
    </Section>

    {#if details.type === 'TOOL'}
      <Section title={`${sgettext('$$TOOLS$$')} (${details.tools.length})`}>
        {#if contextualEdit}
          <ToolTable rows={details.tools} />
        {:else}
          <ToolEditor
            bind:rows={details.tools}
            elementId={details.elementId}
            {elementVersionId}
            eevId={details.eevId}
          />
        {/if}
      </Section>
    {/if}

    <Section
      title={`${sgettext('$$REFERENCE_DOCUMENTS$$')} (${
        details.reference_documents.length
      })`}
    >
      {#if contextualEdit}
        <ReferenceDocumentTable rows={details.reference_documents} />
      {:else}
        <ReferenceDocumentEditor
          bind:rows={details.reference_documents}
          eevId={details.eevId}
          elementVersionId={details.evId}
          details="details"
        />
      {/if}
    </Section>

    <PromoteToCurrent
      id={promoteToCurrentModalId}
      eevId={details.eevId}
      activityVersionId={$activityVersion ? $activityVersion.id : 0}
      onSuccess={onPromotedToCurrent}
      {fioriGoverned}
      {apmGoverned}
      commentRequired={details.version > 1}
    />
  {/if}

  {#if details && details.elementId && !contextualEdit}
    <div class="editor-footer-actions mt-5">
      <Button
        name={sgettext('$$DELETE_DRAFT_1$$')}
        type="secondary"
        sending={deletingDraft}
        on:click={showDeleteDraftConfirmation}
      />

      {#if showWarning > 0}
        <Button
          name={sgettext('$$SAVE_CURRENT$$')}
          tooltip={sgettext('$$ELEMENT_CANNOT_PROMOTED_CONTAINS_INVALID$$')}
          type="primary"
          style="cursor: not-allowed; background-color: rgb(229, 229, 229) !important;border-color: rgb(229, 229, 229) !important;"
        />
        <Button
          name={sgettext('$$SAVE_CURRENT_NEW$$')}
          type="primary"
          tooltip={sgettext('$$ELEMENT_CANNOT_PROMOTED_CONTAINS_INVALID$$')}
          style="cursor: not-allowed; background-color: rgb(229, 229, 229) !important;border-color: rgb(229, 229, 229) !important;"
        />
      {:else}
        <Button
          name={sgettext('$$SAVE_CURRENT$$')}
          type="primary"
          sending={savingAsCurrent}
          on:click={showPromoteToCurrentOnClick}
        />

        <Button
          name={sgettext('$$SAVE_CURRENT_NEW$$')}
          type="primary"
          sending={savingAsCurrentAddNew}
          on:click={showPromoteToCurrentAddNew}
        />
      {/if}
    </div>

    <ElementMediaLibrary
      id={elementMediaLibraryId}
      title={elementMediaLibraryTitle}
      elementId={details.elementId}
      uploadApi={elementMediaUploadApi.replace('{0}', details.elementId)}
      on:selected={handleSelectedMedia}
    />

    <ElementMediaMarker
      {markupMediaModalId}
      bind:elementSlideId={selectedSlideId}
      onSave={onMarkerModalSave}
      onCancel={onMarkerModalCancel}
      onMarkupRemovalConfirmed={removeMarkupConfirmed}
      iframeSrc={markupMediaApi}
      sending={savingMarkup}
    />

    <ConfirmationModal
      id={deleteMainMediaConfirmationId}
      title={sgettext('$$DELETE_CONFIRMATION$$')}
      onYes={removeMainMedia}
      onNo={cancelDeleteMainMedia}
      sending={deletingMainMedia}
    >
      <div slot="message">
        <p>{sgettext('$$SURE_WANT_DELETE_PHOTO$$')}</p>
        {#if details.element_slide}
          <Thumbnail
            url={details.element_slide.thumbnail}
            media={details.element_slide.url}
            type={details.element_slide.type}
          />
        {/if}
        <br />
      </div>
    </ConfirmationModal>

    <ConfirmationModal
      id={deleteDraftConfirmationId}
      title={sgettext('$$DELETE_CONFIRMATION$$')}
      onYes={deleteDraftVersion}
      onNo={closeDeleteDraftModal}
      sending={deletingDraft}
    >
      <div slot="message">
        <p>
          {sgettext('$$SURE_WANT_DELETE$$')} "{details.name}: {sgettext(
            '$$VERSION_2$$'
          )}{details.version}"?
        </p>
        {#if activityUsage.length}
          <p>
            <strong>{sgettext('$$FOLLOWING_ACTIVITIES_AFFECTED$$')}:</strong>
          </p>
          <div class="activity-usage">
            {#each activityUsage as item}
              <ActivityUsageItem {item} />
            {/each}
          </div>
        {/if}
        <br />
        <p>
          <strong>
            {sgettext('$$NOTE_DELETE_CHILDREN_OBJECTS_CANNOT$$')}
          </strong>
        </p>
      </div>
    </ConfirmationModal>
  {/if}

  {#if details && details.elementId && contextualEdit}
    <ConfirmationModal
      id={deleteContextualMediaConfirmationId}
      title={sgettext('$$DELETE_CONFIRMATION$$')}
      onYes={removeContextualMedia}
      onNo={cancelDeleteContextualMedia}
      sending={deletingContextualMedia}
    >
      <div slot="message">
        <p>{sgettext('$$SURE_WANT_DELETE_PHOTO$$')}</p>
        {#if details.contextual_photo}
          <Thumbnail
            url={details.contextual_photo.url}
            media={details.contextual_photo.url}
            type={details.contextual_photo.type}
          />
        {/if}
        <br />
      </div>
    </ConfirmationModal>
  {/if}
{/if}

<svelte:head>
  <style>
    /*This would all go into the global.css file*/
    [data-tooltip] {
      position: relative;
      z-index: 2;
    }

    [data-tooltip]:before,
    [data-tooltip]:after {
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      transition: 0.2s ease-out;
      transform: translate(-50%, 5px);
    }

    [data-tooltip]:before {
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-bottom: 5px;
      padding: 3px;
      width: 100%;
      min-width: 70px;
      max-width: 250px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      background-color: #000 !important;
      color: #fff;
      content: attr(data-tooltip);
      text-align: center;
      font-size: 14px;
      line-height: 1.2;
      transition: 0.2s ease-out;
    }

    [data-tooltip]:after {
      position: absolute;
      bottom: 100%;
      left: 50%;
      width: 0;
      border-top: 5px solid #000;
      border-top: 5px solid hsla(0, 0%, 20%, 0.9);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      content: ' ';
      font-size: 0;
      line-height: 0;
      color: #fff;
    }

    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
      visibility: visible;
      opacity: 1;
      transform: translate(-50%, 0);
    }
    [data-tooltip='false']:hover:before,
    [data-tooltip='false']:hover:after {
      visibility: hidden;
      opacity: 0;
    }
  </style>
</svelte:head>

<style>
  table {
    width: 100%;
  }

  th {
    vertical-align: top;
  }

  th,
  td {
    padding: 5px 0;
  }

  .details-row {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 15px;
  }

  @media (max-width: 1600px) {
    .details-row {
      grid-template-columns: 1fr;
    }
  }

  section {
    padding-top: 2rem;
  }

  .title {
    margin-bottom: 15px;
  }

  .title h2 {
    margin-bottom: 0px;
  }

  .title h3 {
    color: var(--gray-dark);
  }

  .title label {
    color: #454545;
  }

  .btn-link {
    cursor: pointer;
  }

  .buttons-bar {
    padding: 15px 0;
    text-align: end;
  }

  .buttons-bar :global(.btn) {
    min-width: 80px;
    margin-left: 10px;
  }

  .editor-footer-actions {
    display: flex;
  }

  .editor-footer-actions :global(button) {
    margin-right: 15px;
  }

  /* This block of CSS was adapted from here https://stackoverflow.com/a/49065029/6487048
      It forces the main photo section to dynamically match the height of the form to its left. */
  .general-details-flex-wrapper {
    display: flex;
  }

  :global(.sm) .general-details-flex-wrapper {
    flex-direction: column;
  }

  .general-details {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  #general-details tr:last-child td:last-child {
    padding-bottom: 0;
  }

  #general-details th:first-child {
    width: 20%;
    padding-right: 15px;
  }

  span[slot='linkLabel'] {
    font-size: 16px;
  }

  #general-details th:nth-child(3) {
    min-width: 90px;
  }

  #general-details td:nth-child(4) {
    min-width: 90px;
  }

  .media {
    height: 100%;
  }

  .main-photo,
  .media {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 360px;
  }

  :global([data-toggle='collapse'].collapsed i) {
    transform: rotate(-90deg);
  }

  .edit {
    padding: 15px;
  }

  .greyBackground {
    background-color: #edf1f2;
  }

  :global(section.contextual-edit div.wrapper) {
    background-color: #e5f5ff !important;
  }

  :global(section.contextual-edit) #elementEditor {
    background-color: #e5f5ff;
  }

  :global(section.contextual-edit :is(.drop-area)) {
    background-color: #bce5ff;
    border-color: #40a0dc;
    color: #00427b;
  }

  input {
    height: 32px;
    width: 32px;
    margin-left: 15px;
  }
  :global(section.contextual-edit) div :global(.main-photo-container label) {
    color: #0b6cb3;
  }

  :global(.contextual-input :is(input, .drop-area), input.contextual-input) {
    background-color: #bce5ff !important;
    border-color: #40a0dc !important;
    color: #00427b !important;
  }

  :global(.contextualLabel) {
    color: #0b6cb3;
  }

  :global(section.contextual-edit div.section-content) {
    border: 1px solid #ced4da;
  }

  .activity-usage {
    border: 1px solid #dddddd;
    border-bottom: none;
  }

  .main-photo-container {
    height: 100%;
    overflow: hidden;
  }

  #general-details th {
    vertical-align: middle;
  }

  :global(button[title]:hover::after) {
    content: attr(title);
    position: absolute;
    top: -100%;
    left: 0;
    color: red;
  }
  /* button:hover:after { 
        content: "Hi"; 
        font-family: Arial;
        position: absolute;
        top: 0;
        width: 20px;
        height: 1.25rem;   
        background-color: gray;
        color: white;
    } */
  .wrapper {
    width: 30px;
    background-color: black;
    color: white;
  }
</style>
